import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="border-y border-charcoal-line bg-charcoal px-4 py-20" data-id="element-132">
      <div className="mx-auto max-w-4xl" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative overflow-hidden rounded-3xl border border-gold/35 bg-charcoal-card p-8 text-center sm:p-12" data-id="element-134">
          <div className="absolute inset-x-0 top-0 h-1 bg-gold" data-id="element-135" />
          <div className="mx-auto flex size-20 items-center justify-center rounded-full border-2 border-gold bg-gold/10" data-id="element-136">
            <ShieldCheckIcon size={42} className="text-gold-light" data-id="element-137" />
          </div>
          <h2 className="mt-6 font-display text-3xl font-bold text-white sm:text-4xl" data-id="element-138">
            Full 7-Day Money-Back Guarantee
          </h2>
          <div className="mx-auto mt-6 max-w-2xl space-y-5 text-base leading-relaxed text-zinc-300 sm:text-lg" data-id="element-139">
            <p data-id="element-140">
              Open the entire teaching system. Explore all 5 bonuses. Use the
              material in your most challenging class this week.
            </p>
            <p data-id="element-141">
              Put the choreography systems to work. Test the cueing sheets. Try
              the 60-minute class templates.
            </p>
            <p className="font-medium text-white" data-id="element-142">
              If you feel the material is not clear, practical, or genuinely
              useful for your teaching needs — contact us within 7 days.
            </p>
            <p className="font-bold text-gold-light" data-id="element-143">
              We will refund 100% of your money. No questions. No forms. No
              complications. No waiting.
            </p>
            <p className="pt-3 text-sm text-zinc-500" data-id="element-144">
              Because if the material does not deliver the value we promise, we
              do not want your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}